import {
  captureStack1fzi4aczwc4hg as captureStack,
  createExternalThis2k2orr8ix0ytc as createExternalThis,
  setPropertiesToThrowableInstance1w2jjvl9y77yc as setPropertiesToThrowableInstance,
  setupCauseParameter20kc7dphipdif as setupCauseParameter,
  toString1pkumu07cwy4m as toString,
} from './js/coreRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from './Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from './js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlin_Exception(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.sd_1);
}
var ExceptionClass;
function Exception() {
  if (ExceptionClass === VOID) {
    class $ extends Error {
      static td() {
        var $this = createExternalThis(this, Error, [null]);
        setPropertiesToThrowableInstance($this);
        init_kotlin_Exception($this);
        return $this;
      }
      static ud(message) {
        var $this = createExternalThis(this, Error, [message]);
        setPropertiesToThrowableInstance($this, message);
        init_kotlin_Exception($this);
        return $this;
      }
      static vd(message, cause) {
        var $this = createExternalThis(this, Error, [message, setupCauseParameter(cause)]);
        setPropertiesToThrowableInstance($this, message, cause);
        init_kotlin_Exception($this);
        return $this;
      }
      static wd(cause) {
        var $this = createExternalThis(this, Error, [null, setupCauseParameter(cause)]);
        setPropertiesToThrowableInstance($this, VOID, cause);
        init_kotlin_Exception($this);
        return $this;
      }
    }
    initMetadataForClass($, 'Exception', $.td);
    ExceptionClass = $;
  }
  return ExceptionClass;
}
function init_kotlin_IllegalArgumentException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.z_1);
}
var IllegalArgumentExceptionClass;
function IllegalArgumentException() {
  if (IllegalArgumentExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static xd() {
        var $this = this.yd();
        init_kotlin_IllegalArgumentException($this);
        return $this;
      }
      static a1(message) {
        var $this = this.ua(message);
        init_kotlin_IllegalArgumentException($this);
        return $this;
      }
      static zd(message, cause) {
        var $this = this.ae(message, cause);
        init_kotlin_IllegalArgumentException($this);
        return $this;
      }
      static be(cause) {
        var $this = this.ce(cause);
        init_kotlin_IllegalArgumentException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalArgumentException', $.xd);
    IllegalArgumentExceptionClass = $;
  }
  return IllegalArgumentExceptionClass;
}
function init_kotlin_IllegalStateException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.n4_1);
}
var IllegalStateExceptionClass;
function IllegalStateException() {
  if (IllegalStateExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static kd() {
        var $this = this.yd();
        init_kotlin_IllegalStateException($this);
        return $this;
      }
      static o4(message) {
        var $this = this.ua(message);
        init_kotlin_IllegalStateException($this);
        return $this;
      }
      static nd(message, cause) {
        var $this = this.ae(message, cause);
        init_kotlin_IllegalStateException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalStateException', $.kd);
    IllegalStateExceptionClass = $;
  }
  return IllegalStateExceptionClass;
}
function init_kotlin_UnsupportedOperationException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.h5_1);
}
var UnsupportedOperationExceptionClass;
function UnsupportedOperationException() {
  if (UnsupportedOperationExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static f8() {
        var $this = this.yd();
        init_kotlin_UnsupportedOperationException($this);
        return $this;
      }
      static i5(message) {
        var $this = this.ua(message);
        init_kotlin_UnsupportedOperationException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'UnsupportedOperationException', $.f8);
    UnsupportedOperationExceptionClass = $;
  }
  return UnsupportedOperationExceptionClass;
}
function init_kotlin_RuntimeException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.ta_1);
}
var RuntimeExceptionClass;
function RuntimeException() {
  if (RuntimeExceptionClass === VOID) {
    class $ extends Exception() {
      static yd() {
        var $this = this.td();
        init_kotlin_RuntimeException($this);
        return $this;
      }
      static ua(message) {
        var $this = this.ud(message);
        init_kotlin_RuntimeException($this);
        return $this;
      }
      static ae(message, cause) {
        var $this = this.vd(message, cause);
        init_kotlin_RuntimeException($this);
        return $this;
      }
      static ce(cause) {
        var $this = this.wd(cause);
        init_kotlin_RuntimeException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'RuntimeException', $.yd);
    RuntimeExceptionClass = $;
  }
  return RuntimeExceptionClass;
}
function init_kotlin_NoSuchElementException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.n_1);
}
var NoSuchElementExceptionClass;
function NoSuchElementException() {
  if (NoSuchElementExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static y1() {
        var $this = this.yd();
        init_kotlin_NoSuchElementException($this);
        return $this;
      }
      static o(message) {
        var $this = this.ua(message);
        init_kotlin_NoSuchElementException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'NoSuchElementException', $.y1);
    NoSuchElementExceptionClass = $;
  }
  return NoSuchElementExceptionClass;
}
function init_kotlin_Error(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.h_1);
}
var ErrorClass;
function Error_0() {
  if (ErrorClass === VOID) {
    class $ extends Error {
      static de() {
        var $this = createExternalThis(this, Error, [null]);
        setPropertiesToThrowableInstance($this);
        init_kotlin_Error($this);
        return $this;
      }
      static i(message) {
        var $this = createExternalThis(this, Error, [message]);
        setPropertiesToThrowableInstance($this, message);
        init_kotlin_Error($this);
        return $this;
      }
      static ee(message, cause) {
        var $this = createExternalThis(this, Error, [message, setupCauseParameter(cause)]);
        setPropertiesToThrowableInstance($this, message, cause);
        init_kotlin_Error($this);
        return $this;
      }
    }
    initMetadataForClass($, 'Error', $.de);
    ErrorClass = $;
  }
  return ErrorClass;
}
function init_kotlin_IndexOutOfBoundsException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.he_1);
}
var IndexOutOfBoundsExceptionClass;
function IndexOutOfBoundsException() {
  if (IndexOutOfBoundsExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static ie() {
        var $this = this.yd();
        init_kotlin_IndexOutOfBoundsException($this);
        return $this;
      }
      static je(message) {
        var $this = this.ua(message);
        init_kotlin_IndexOutOfBoundsException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'IndexOutOfBoundsException', $.ie);
    IndexOutOfBoundsExceptionClass = $;
  }
  return IndexOutOfBoundsExceptionClass;
}
function init_kotlin_ArithmeticException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.me_1);
}
var ArithmeticExceptionClass;
function ArithmeticException() {
  if (ArithmeticExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static ne() {
        var $this = this.yd();
        init_kotlin_ArithmeticException($this);
        return $this;
      }
      static oe(message) {
        var $this = this.ua(message);
        init_kotlin_ArithmeticException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'ArithmeticException', $.ne);
    ArithmeticExceptionClass = $;
  }
  return ArithmeticExceptionClass;
}
function init_kotlin_ClassCastException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.z4_1);
}
var ClassCastExceptionClass;
function ClassCastException() {
  if (ClassCastExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static a5() {
        var $this = this.yd();
        init_kotlin_ClassCastException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'ClassCastException', $.a5);
    ClassCastExceptionClass = $;
  }
  return ClassCastExceptionClass;
}
function init_kotlin_NullPointerException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.r4_1);
}
var NullPointerExceptionClass;
function NullPointerException() {
  if (NullPointerExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static s4() {
        var $this = this.yd();
        init_kotlin_NullPointerException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'NullPointerException', $.s4);
    NullPointerExceptionClass = $;
  }
  return NullPointerExceptionClass;
}
function init_kotlin_AssertionError(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.qe_1);
}
var AssertionErrorClass;
function AssertionError() {
  if (AssertionErrorClass === VOID) {
    class $ extends Error_0() {
      static re() {
        var $this = this.de();
        init_kotlin_AssertionError($this);
        return $this;
      }
      static se(message) {
        var tmp = message == null ? null : toString(message);
        var $this = this.ee(tmp, message instanceof Error ? message : null);
        init_kotlin_AssertionError($this);
        return $this;
      }
    }
    initMetadataForClass($, 'AssertionError', $.re);
    AssertionErrorClass = $;
  }
  return AssertionErrorClass;
}
function init_kotlin_NumberFormatException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.we_1);
}
var NumberFormatExceptionClass;
function NumberFormatException() {
  if (NumberFormatExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static xe() {
        var $this = this.xd();
        init_kotlin_NumberFormatException($this);
        return $this;
      }
      static ye(message) {
        var $this = this.a1(message);
        init_kotlin_NumberFormatException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'NumberFormatException', $.xe);
    NumberFormatExceptionClass = $;
  }
  return NumberFormatExceptionClass;
}
function init_kotlin_ConcurrentModificationException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.na_1);
}
var ConcurrentModificationExceptionClass;
function ConcurrentModificationException() {
  if (ConcurrentModificationExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static gb() {
        var $this = this.yd();
        init_kotlin_ConcurrentModificationException($this);
        return $this;
      }
      static oa(message) {
        var $this = this.ua(message);
        init_kotlin_ConcurrentModificationException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'ConcurrentModificationException', $.gb);
    ConcurrentModificationExceptionClass = $;
  }
  return ConcurrentModificationExceptionClass;
}
function init_kotlin_NoWhenBranchMatchedException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.v4_1);
}
var NoWhenBranchMatchedExceptionClass;
function NoWhenBranchMatchedException() {
  if (NoWhenBranchMatchedExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static w4() {
        var $this = this.yd();
        init_kotlin_NoWhenBranchMatchedException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'NoWhenBranchMatchedException', $.w4);
    NoWhenBranchMatchedExceptionClass = $;
  }
  return NoWhenBranchMatchedExceptionClass;
}
function init_kotlin_UninitializedPropertyAccessException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.d5_1);
}
var UninitializedPropertyAccessExceptionClass;
function UninitializedPropertyAccessException() {
  if (UninitializedPropertyAccessExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static ze() {
        var $this = this.yd();
        init_kotlin_UninitializedPropertyAccessException($this);
        return $this;
      }
      static e5(message) {
        var $this = this.ua(message);
        init_kotlin_UninitializedPropertyAccessException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'UninitializedPropertyAccessException', $.ze);
    UninitializedPropertyAccessExceptionClass = $;
  }
  return UninitializedPropertyAccessExceptionClass;
}
//region block: exports
export {
  ArithmeticException as ArithmeticException18dajwq7kbp38,
  AssertionError as AssertionError3yq7q0knw9m5,
  ClassCastException as ClassCastException1atiay3nqgbd,
  ConcurrentModificationException as ConcurrentModificationException3974vl9oonkcj,
  Error_0 as Error3ofk6owajcepa,
  Exception as Exceptiondt2hlxn7j7vw,
  IllegalArgumentException as IllegalArgumentException2asla15b5jaob,
  IllegalStateException as IllegalStateExceptionkoljg5n0nrlr,
  IndexOutOfBoundsException as IndexOutOfBoundsException1qfr429iumro0,
  NoSuchElementException as NoSuchElementException679xzhnp5bpj,
  NoWhenBranchMatchedException as NoWhenBranchMatchedException3krrgsc7u48pz,
  NullPointerException as NullPointerException3mu0rhxjjitqq,
  NumberFormatException as NumberFormatException3bgsm2s9o4t55,
  RuntimeException as RuntimeException1r3t0zl97011n,
  UninitializedPropertyAccessException as UninitializedPropertyAccessException8qin22n38p0w,
  UnsupportedOperationException as UnsupportedOperationException2tkumpmhredt3,
};
//endregion

//# sourceMappingURL=exceptions.mjs.map
